import React from 'react';

import { ITabElement } from '../../components/common/Tabs/types';

import ClassicDuelForm, { IClassicDuelFormProps } from './forms/ClassicDuel';
import QuickDuelForm, { IQuickDuelFormProps } from './forms/QuickDuel';
import TeamDuelForm from './forms/TeamDuel';

export const flyoutTabs = (props: IClassicDuelFormProps & IQuickDuelFormProps): ITabElement[] => [
  {
    title: 'classic',
    mode: 'classic game',
    component: <ClassicDuelForm {...props} />,
    queryParam: 'classic_duel',
  },
  {
    title: 'quick',
    mode: 'quick game',
    component: <QuickDuelForm {...props} />,
    queryParam: 'quick_duel',
  },
  {
    title: 'team',
    mode: 'team game',
    component: <TeamDuelForm {...props} />,
    queryParam: 'team_duel',
  },
];
